import { Box, Typography } from "@mui/material";
//import BardTimeSheet from "./component/BardTimeSheet";
import { CalendarDateSelector } from "../CalendarDateSelector";
import BardTimeSheet from "./component/BardTimeSheet";

import { useMemo, useState } from "react";
import { useWatchTimeSheetNotifications } from "../../notifications/hooks/useWatchTimeSheetNotifications";
import CardInfoWorkforce from "./component/time-sheet-logs/components/CardInfoWorkforce";
import TableSheetLogs from "./component/time-sheet-logs/components/TableSheetLogs";
import { useTimeSheetFilters } from "./hooks/useTImeSheetFilters";
import { useTimeSheetsQuery } from "./hooks/useTImeSheetsQuery";
import { TimeSheetSearchSuggestion } from "./interfaces/time-sheet.interfaces";

export default function TimeSheet() {
  const { selectedWorker, setSelectedWorker, setDateRange, queryFilters, clearAllFilters, page, pageSize, setPage, setPageSize } =
    useTimeSheetFilters();

  const [selectedSearch, setSelectedSearch] = useState<TimeSheetSearchSuggestion | null>(null);

  const timeSheetQueryFilters = useMemo(() => {
    return {
      ...queryFilters,
      ...(selectedSearch?.query ?? {}),
    };
  }, [queryFilters, selectedSearch]);

  const { data: timeSheetsResponse, isLoading, refetch } = useTimeSheetsQuery(timeSheetQueryFilters);

  useWatchTimeSheetNotifications({
    onNotificationArrived: () => {
      refetch();
    },
    dissableSnackbarAlert: true,
  });

  const filterKey = useMemo(() => {
    return `${selectedWorker?.uid ?? "global"}-${selectedSearch?.value ?? ""}-${timeSheetQueryFilters.day ?? ""}-${timeSheetQueryFilters.range?.start ?? ""}-${timeSheetQueryFilters.range?.end ?? ""}`;
  }, [selectedWorker, selectedSearch, timeSheetQueryFilters]);

  return (
    <Box sx={{ background: "var(--fx-surface-sunken, #F8FAFC)", padding: 3, overflow: "auto" }}>
      <Typography sx={{ fontSize: 30, fontWeight: 900 }}>TimeSheets</Typography>

      <Box display="flex" alignItems="center" gap={2} marginBottom={2}>
        <BardTimeSheet value={selectedSearch} onSearchSelect={setSelectedSearch} />

        {selectedSearch && (
          <CardInfoWorkforce email={selectedSearch.subtitle ?? ""} alias={selectedSearch.label} removeWorkforce={() => setSelectedSearch(null)} />
        )}
      </Box>

      <Box display="flex" gap={1} alignItems="flex-start">
        <TableSheetLogs
          key={filterKey}
          isGlobal={!selectedWorker && !selectedSearch?.query?.workerUid}
          timeSheets={timeSheetsResponse?.data ?? []}
          isLoading={isLoading}
          onSelectWorker={setSelectedWorker}
          onClearFilters={clearAllFilters}
          pagination={{
            page,
            pageSize,
            setPage,
            setPageSize,
            total: timeSheetsResponse?.totalEvents ?? 0,
          }}
        />

        <CalendarDateSelector onFilter={setDateRange} modes={["day", "week", "month", "quarter", "year"]} defaultMode="day" />
      </Box>
    </Box>
  );
}
